<template>
  <div class="px-3" style="padding-right: 20px">
    <router-link  v-if="balance" :to="{ name: 'balance' }" class="block text-sm text-gray-200 hover:text-blue-950">
      <span class="px-1">Баланс</span>
      <span>{{balance.amount}}</span>
      <span class="px-1">р.</span>
    </router-link>
    <div v-else class="text-gray-200">
      <span class="px-1">Баланс: -</span>
    </div>
  </div>
</template>

<script>
import store from '@/store.js'

export default {
  name: 'TopBalance',
  data() {
    return {
      store,
      balance: null
    }
  },
  methods: {
    loadBalance: function () {
      console.log("loadBalance")
      let c = this;
      this.axios.get('/api/profile/balance', this.formData).then(function(response) {
        console.log(response.data);
        c.balance = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
      });
    }
  },
  mounted() {
    this.loadBalance()
  }
}
</script>

<style scoped>

</style>